// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2o6lf","large":"styles_large__3H1FG"};